'use client'

import { useEffect, useState } from 'react'

interface NavShellProps {
  children: React.ReactNode
}

/**
 * Floating island navbar shell — fixed to the top edge with inset padding.
 * The scrolled state applies via a data attribute over a CONSTANT className:
 * state-branched class strings hydrate inconsistently when scroll restoration
 * races hydration, while data-attribute styling cannot mismatch.
 */
export function NavShell({ children }: NavShellProps) {
  const [solid, setSolid] = useState<boolean>(false)

  useEffect(() => {
    const handleScroll = (): void => {
      setSolid(window.scrollY > 80)
    }
    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <header className="fixed inset-x-0 top-0 z-50 px-3 pt-3 md:px-4 md:pt-4">
      <div
        data-solid={solid ? 'true' : undefined}
        suppressHydrationWarning
        className="border-border/70 bg-bg/90 shadow-card data-[solid=true]:border-border data-[solid=true]:bg-bg relative mx-auto flex h-14 max-w-6xl items-center justify-between gap-2 rounded-full border px-4 backdrop-blur transition-[background-color,border-color,box-shadow] duration-300 data-[solid=true]:shadow-[0_8px_30px_-12px_rgba(17,24,39,0.22)] md:px-4"
      >
        {children}
      </div>
    </header>
  )
}
